import campaignContext from 'common/src/modules/campaigns/copilot/contexts/campaignContext';
import {AgentName} from 'common/src/modules/shared/copilot/copilot.enums';
import {Agent, Tool} from 'common/src/modules/shared/copilot/copilot.types';
import agent from 'common/src/modules/shared/copilot/utils/creators/agent';
import {CLStore} from 'common/src/redux/store';
import {ZodTypeAny} from 'zod';

function socialCampaignSetupAgent(store: CLStore): Agent {
  const role = 'You are the agent responsible for social campaign setup and configuration.';

  const inScope = ['Set up and configure social campaigns', 'create ad sets'];

  const instructions = `### Background

You are a social campaign setup specialist that helps users configure social media advertising campaigns across various platforms including Facebook, YouTube, TikTok, Snapchat, and LinkedIn.
`;

  const tools: Tool<ZodTypeAny>[] = [
    // Add social campaign setup tools
  ];

  const contexts = [campaignContext(store)];

  return agent({
    name: AgentName.SocialCampaignSetup,
    role,
    store,
    instructions,
    tools,
    inScope,
    contexts,
  });
}

export default socialCampaignSetupAgent;
